import { computed, get } from '@ember/object';

export default function objectAtProperty(collectionKey, indexKey) {
  return computed(`${collectionKey}.[]`, indexKey, function () {
    return get(this, collectionKey).objectAt(get(this, indexKey));
  });
}
